import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectSmall({
    takeAddress,
}) {
  const [address, setAddress] = React.useState('');

  const handleChange = (event) => {
    setAddress(event.target.value);
  };

  takeAddress(address)

  return (
    <FormControl sx={{ 
        m: 1, 
        minWidth: 200, 
            '.MuiOutlinedInput-notchedOutline': {
              border: '2px solid #50DAA8',
            } 
            }} size="small">
      <InputLabel id="demo-select-small-label">Оберіть адресу</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={address}
        label="address"
        onChange={handleChange}
      >
        {/* <MenuItem value="">
          <em>None</em>
        </MenuItem> */}
        <MenuItem value={'вул. Віталія Вергая 8'}>вул. Віталія Вергая 8</MenuItem>
        <MenuItem value={'вул. Нарбутівська 171/2'}>вул. Нарбутівська 171/2</MenuItem>
      </Select>
    </FormControl>
  );
}